export const defaultMinDate = new Date('1900-01-01');
export const defaultMaxDate = new Date('2099-12-31');